module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar-popup-menu"
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "dense": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "alt": _vm.item && _vm.item.user && _vm.item.user.avatar ? _vm.item.user.avatar : 'default-avatar.gif',
      "src": _vm.item && _vm.item.user && _vm.item.user.avatar ? _vm.item.user.avatar : require('@/assets/images/default-avatar.gif')
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "font-size": "15px",
      "font-weight": "900",
      "text-transform": "capitalize"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    })
  }, [_vm._v(_vm._s(_vm.item.user.firstname + ' ' + _vm.item.user.lastname))]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('div', {
    staticStyle: {
      "color": "#000",
      "font-size": "15px"
    }
  }, [_vm._v(_vm._s(_vm.item.user.jobtitle) + " "), (_vm.item.user.jobtitle && _vm.item.company) ? _c('span', [_vm._v("|\n              " + _vm._s(_vm.item.company.companylegalname))]) : _vm._e()])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "avatar-popup-action"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.openChat(_vm.uid)
      }
    }
  }, [_vm._v("Message")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16335317","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/AvatarPopup.vue
// module id = 1219
// module chunks = 16 17